import React from "react";
import { BackgroundImage, TeethLogo, ServiceBottomButton } from "../../Components"
import oral_surgery from "../../assets/Images/oral-surgery-home.jpg"

const OralSurgery = (props) => {
    const { selectedLanguage } = props

    return (
        <div className="main">
            <BackgroundImage heading={selectedLanguage?.services_oral_surgery} text={selectedLanguage?.txt_explore_our_services} mainClass='oral-surgery-background' />
            <TeethLogo heading={selectedLanguage?.services_oral_surgery} />
            <div className="dental-service-main">
                <div className="dental-service-img-div">
                    <img src={oral_surgery} alt="dentalImg" />
                </div>
                <div className="dental-service-text-div">
                    <p>{selectedLanguage?.oral_surgery_pargraph_oral_surgery_basically_involves}</p>
                    <p>{selectedLanguage?.oral_surgery_pargraph_at_primadent_we_have_revolutionized}</p>
                    <p>{selectedLanguage?.oral_surgery_pargraph_in_our_clinic_oral_surgery}</p>
                </div>
            </div>
            <ServiceBottomButton {...props} />
        </div>
    )
}

export default OralSurgery